export default __webpack_public_path__ + "static/media/delete1.eaf8a42c.svg";